#@import Booking.Presenters.Base
#@export Booking.Presenters.TimeBubbles

class Booking.Presenters.TimeBubbles extends Booking.Presenters.Base

  toHash: ->
    isMultiWindow: @model.isMultiWindow()
    bhcAnytime: 'input:anytimeBubble'
